export enum ViewModalActionsBlock {
  Root = 'ViewModalActions',
}

export enum ViewModalActionsElement {
  Reset = 'reset',
  Run = 'run',
  Save = 'save',
}
